import { login } from '../login';
import env from '../../config';

interface ITokenData {

    name: string;
    email: string;
    roles: Array<any> | string;
    companyid: number;

}

export class AuthService {

    static $inject = ['localStorageService', '$window', '$state', '$q', '$timeout', 'Restangular'];

    constructor(
        private localStorageService: ng.local.storage.ILocalStorageService,
        private $window: ng.IWindowService, 
        private $state: ng.ui.IStateService,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private Restangular: Restangular.IService
    ) {


    }

    public isAuthorized = (role = null): ng.IPromise<any> => {
        var deferred = this.$q.defer();
        if (this.localStorageService.get("authorizationData") != null && this.localStorageService.get("authorizationData") != "") {
            if (role && !this.hasRole(role)) {
                deferred.reject({
                    code: 401, text: 'Insufficient roles' });
            }
            deferred.resolve({ code: 200 });
        } else {
            deferred.reject({ code: 403 });
        }
        return deferred.promise;
    }

    public setTokenHeader = () => {
        this.Restangular.setDefaultHeaders({ 'Authorization': 'Bearer ' + this.localStorageService.get("authorizationData")});
    }

    public hasRole = (role) => {
        var roles = this.getRoles();
        if (roles instanceof Array) {
            return (roles.indexOf(role) > -1);
        } else {
            return (roles == role);
        }
    }

    public getRoles = () => {

        var data:any = this.getDataFromToken(this.GetAuthorizationData());
        return data.role;

    }

    public getTokenData = () => {

        if (this.GetAuthorizationData()) {
            var data: any = this.getDataFromToken(this.GetAuthorizationData());
            return data;
        }
        return false;

    }

    public authorize = () => {

        // console.log("AuthorizedController time to log on");

        var authorizationUrl = env.AUTH_LOGIN_URL;
        var client_id = env.AUTH_CLIENT_ID;
        var redirect_uri = this.$window.location.origin + '/authorized';
        var response_type = "id_token token";
        var scope = env.AUTH_SCOPES;
        var nonce = "N" + Math.random() + "" + Date.now();
        var state = Date.now() + "" + Math.random();

        this.localStorageService.set("authNonce", nonce);
        this.localStorageService.set("authStateControl", state);
        // console.log("AuthorizedController created. adding myautostate: " + this.localStorageService.get("authStateControl"));

        var url =
            authorizationUrl + "?" +
            "response_type=" + encodeURI(response_type) + "&" +
            "client_id=" + encodeURI(client_id) + "&" +
            "redirect_uri=" + encodeURI(redirect_uri) + "&" +
            "scope=" + encodeURI(scope) + "&" +
            "nonce=" + encodeURI(nonce) + "&" +
            "state=" + encodeURI(state);

        // console.log(url);
        this.$window.location.href = url;
    }
   
    public logout = () => {

        var id_token = this.localStorageService.get("authorizationDataIdToken");
        var authorizationUrl = env.AUTH_LOGOUT_URL;
        var id_token_hint = id_token;
        var post_logout_redirect_uri = this.$window.location.origin + '';
        var state = Date.now() + "" + Math.random();

        var url =
            authorizationUrl + "?" +
            "id_token_hint=" + id_token_hint + "&" +
            "post_logout_redirect_uri=" + encodeURI(post_logout_redirect_uri) + "&" +
            "state=" + encodeURI(state);

        this.ResetAuthorizationData();
        this.$window.location.href = url;
    }


    public authorizeCallback = () => {

        // console.log("AuthorizedController created, has hash");
        var hash = window.location.hash.substr(1);

        var result: any = hash.split('&').reduce(function (result, item) {
            var parts = item.split('=');
            result[parts[0]] = parts[1];
            return result;
        }, {});

        var token = "";
        var id_token = "";
        var authResponseIsValid = false;
        if (!result.error) {

            if (result.state !== this.localStorageService.get("authStateControl")) {
                // console.log("AuthorizedCallback incorrect state");
            } else {

                token = result.access_token;
                id_token = result.id_token

                var dataIdToken:any = this.getDataFromToken(id_token);
                // console.log(dataIdToken);

                // validate nonce
                if (dataIdToken.nonce !== this.localStorageService.get("authNonce")) {
                    // console.log("AuthorizedCallback incorrect nonce");
                } else {
                    this.localStorageService.set("authNonce", "");
                    this.localStorageService.set("authStateControl", "");

                    authResponseIsValid = true;
                    // console.log("AuthorizedCallback state and nonce validated, returning access token");
                }
            }
        }

        if (authResponseIsValid) {
            var state = this.$state;
            this.SetAuthorizationData(token, id_token).then(() => {
                //console.log(this.localStorageService.get("authorizationData"));
                this.$window.location.href = this.$window.location.origin;
            });
        }
        else {
            this.ResetAuthorizationData();
            this.$state.go("unauthorized");
        }
    }

    public getEmployeeId(token) {
        var data = this.getDataFromToken(token);
        // console.log(data);
        var userID = (<any>data).employeeId;
        
        return userID;
    }

    public getDataFromToken(token) {
        var data = {};
        if (typeof token !== 'undefined') {
            var encoded = token.split('.')[1];
            data = JSON.parse(this.urlBase64Decode(encoded));
        }
        return data;
    }

    public ResetAuthorizationData = () => {
        this.localStorageService.set("authorizationData", "");
        this.localStorageService.set("authorizationDataIdToken", "");
    }

    public GetAuthorizationData = () => {
        return this.localStorageService.get("authorizationData");
    }

    public SetAuthorizationData = (token, id_token) => {
        // console.log(token);
        var deferred = this.$q.defer();
        this.$timeout(() => {
            if (this.localStorageService.get("authorizationData") !== "") {
                this.localStorageService.set("authorizationData", "");
            }

            this.localStorageService.set("authorizationData", token);
            this.localStorageService.set("authorizationDataIdToken", id_token);
      
                deferred.resolve();
        }, 3000);

        return deferred.promise;

    }

    private urlBase64Decode(str) {
        var output = str.replace('-', '+').replace('_', '/');
        switch (output.length % 4) {
            case 0:
                break;
            case 2:
                output += '==';
                break;
            case 3:
                output += '=';
                break;
            default:
                throw 'Illegal base64url string!';
        }
        return window.atob(output);
    }

}





// WEBPACK FOOTER //
// ./src/app/authorization/services/auth.service.ts